import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  boldTitle: {
    fontWeight: 600,
    cursor: 'pointer',
  },
  readTitle: {
    color: `${(theme as any).palette.primary.main}`,
  },
  defaultColor: {
    color: `${(theme as any).palette.text.notes}`,
  },
  rootOtherInput: {
    borderRadius: '0px',
    fontSize: '1em',
    margin: '0px 5px 0px 5px',
    padding: '5px',
    width: '170px',
  },
}));
